// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".password .submit[data-v-1ea2d19f]{margin:20px}.password .submit .van-button[data-v-1ea2d19f]{width:150px}", ""]);
// Exports
module.exports = exports;
